export function getSearchUrl(text, brand, useAnalogs) {
    return `/search?text=${text}&brand=${encodeURIComponent(brand)}&useAnalogs=${useAnalogs}`;
}
